import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';

import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { UserType } from 'app/core/user/user.types';
import { Settings } from 'app/modules/_common/settings';

@Component({
    selector       : 'user',
    templateUrl    : './user.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'user',
    standalone     : true,
    imports        : [MatButtonModule, MatMenuModule, NgIf, MatIconModule, NgClass, MatDividerModule],
})
export class UserComponent implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    //static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: UserType;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    isHideStatusUserProfile: boolean = false;

    constructor(
        private _userService: UserService,
        private _authService: AuthService,
        private _settings: Settings,
        private _router: Router,
        private _route: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef
    )
    {
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll), filter((raw) => raw != null))
            .subscribe((user: UserType) => {
                this.user = user;

                this._changeDetectorRef.markForCheck();
            });

        this._settings.getSettingsPersonStatus$
            .pipe(takeUntil(this._unsubscribeAll), filter((raw) => raw != null))
            .subscribe((data) => {
                data.items.forEach(({ name, value }) => {
                    name = name.toLowerCase();
                    //console.warn(name, value);
                    if (name == "ishidestatususerprofile") {
                        this.isHideStatusUserProfile = JSON.parse(value);
                    }
                });

                this._changeDetectorRef.markForCheck();
            });
    }

    ngOnInit(): void
    {
    }

    ngOnDestroy(): void
    {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    updateUserStatus(status: string): void
    {
        if (!this.user)
            return;

        //this._userService.update({
        //    ...this.user,
        //    status
        //}).subscribe();
    }

    signOut(): void
    {
        this._router.navigate(['/sign-out']);
    }
}
